"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERR_RESP_SHAPE = {
    shape: {
        type: "structure",
        required: [],
        members: {
            Code: { shape: { type: "string" } },
            Message: { shape: { type: "string" } }
        }
    }
};
//# sourceMappingURL=constants.js.map